const FeaturesListEnum = {
	OFF: 0,
	UPDATE: 1,
	ON: 2,
}

export { FeaturesListEnum }
